export default "__VITE_ASSET__fee75e4f__"